import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export class AtpActionsPopupData {
  constructor(public title: string, public message: string | string[], public successBtnTitle: string = 'Ок', public cancelBtnTitle: string = 'Отмена') { }

  successBtnColor = 'primary';
  titleColor: string;
}

export class AtpActionsPopupComponent<T extends AtpActionsPopupComponent<T>> {

  constructor(@Inject(MAT_DIALOG_DATA) public data: AtpActionsPopupData, protected dialogRef: MatDialogRef<T>) {
    if (typeof (data.message) == 'string') {
      this.message = data.message;
    }
    else {
      this.messages = data.message;
    }
  }

  message: string;
  messages: string[];

  close(result: boolean) {
    this.dialogRef.close(result);
  }

}


@Component({
  selector: 'atp-actions-popup',
  templateUrl: './atp-actions-popup.component.html'
})
export class AtpActionsPopup extends AtpActionsPopupComponent<AtpActionsPopup> {
  constructor(@Inject(MAT_DIALOG_DATA) data: AtpActionsPopupData, dialogRef: MatDialogRef<AtpActionsPopup>) {
    super(data, dialogRef);
  }
}